var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"cont-inner"},[_c('SearchTagBox'),(_vm.hasPopularCellList)?_c('SearchPopularSectionList',{attrs:{"popular-section":_vm.popularSection}}):_c('section',{staticClass:"search-empty"},[_c('p',{staticClass:"dsc"},[_vm._v("잠시 후 시도해주세요")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }